import { apiFetch } from "@/integrations/backend/client";

export interface UpdateProfileInput {
  first_name?: string | null;
  last_name?: string | null;
  bio?: string | null;
  avatar_url?: string | null;
  onboarding_completed?: boolean;
  debugger_enabled?: boolean;
}

export async function updateProfile(_userId: string, input: UpdateProfileInput): Promise<void> {
  const res = await apiFetch("/api/v1/profiles/me", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`profile_update_failed:${res.status}`);
}

export async function uploadAvatar(_userId: string, file: File, _existingUrl?: string | null): Promise<string> {
  const form = new FormData();
  form.append("file", file);
  const res = await apiFetch("/api/v1/profiles/me/avatar", {
    method: "POST",
    body: form,
  });
  if (!res.ok) throw new Error(`avatar_upload_failed:${res.status}`);
  const json = await res.json();
  return json.url as string;
}

export interface ProfileInfo {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  avatar_url: string | null;
  bio?: string | null;
  phone?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export async function getProfileById(profileId: string): Promise<ProfileInfo> {
  const res = await apiFetch(`/api/v1/profiles/${encodeURIComponent(profileId)}`, {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(`get_profile_failed:${res.status}`);
  }
  return (await res.json()) as ProfileInfo;
}

export async function getMyProfile(): Promise<ProfileInfo> {
  const res = await apiFetch("/api/v1/profiles/me", { method: "GET" });
  if (!res.ok) {
    throw new Error(`get_my_profile_failed:${res.status}`);
  }
  return (await res.json()) as ProfileInfo;
}



